import React from 'react';

// Material ui
import { Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';
import TextInput from '@components/UI-KIT/Inputs/TextInput';
import PasswordInput from '@components/UI-KIT/Inputs/PasswordInput';
import Button from '@components/UI-KIT/Button';

interface Props {
    password: string;
    username: string;
    passHandler: (_value: string) => void;
    changeHandler: (_value: string) => void;
    handleEnterPress: (_e: React.KeyboardEvent<HTMLInputElement>) => void;
    submitHandler: () => Promise<void>;
    failLogin: boolean;
    disabled: boolean;
    submitted: boolean;
    setState: React.Dispatch<React.SetStateAction<{
        username: string;
        password: string;
        email: string;
        newPassword: string;
        reEnterPass: string;
        recovery: boolean;
        emailSend: boolean;
        remember: boolean;
        successfulChange: boolean;
        error: {};
    }>>;
}

const SessionForm: React.FC<Props> = ({
    password,
    passHandler,
    handleEnterPress,
    failLogin,
    username,
    changeHandler,
    submitHandler,
    disabled,
    submitted,
    setState
}) => {

    return (
        <>
            <Grid
                className="AOL-Session-main-login-frame"
            >
                <Typography
                    variant="h3"
                    color="primary-dark"
                >
                    Administra tus propiedades y alquileres en un solo lugar
                </Typography>
                <Grid
                    className="AOL-Session-login-forms"
                >
                    <TextInput
                        value={username}
                        onChange={changeHandler}
                        label="¿Cuál es tu usuario?"
                        xs={12}
                    />
                    <Grid
                        className="AOL-Session-login-password"
                    >
                        <PasswordInput
                            value={password}
                            onChange={passHandler}
                            onKeyPress={handleEnterPress}
                            errorCase={failLogin}
                            label="¿Y tu contraseña?"
                            xs={12}
                            errorLabel="Email o contraseña incorrectos"
                        />
                    </Grid>
                </Grid>
                <Grid
                    className="AOL-Session-login-margin"
                >
                    <Button
                        level={1}
                        onClick={submitHandler}
                        disabled={disabled || submitted}
                        label={submitted ? 'Ingresando...' : 'Ingresar'}
                        className="AOL-Session-login-btn"
                    />
                </Grid>
                <Grid
                    className="AOL-Session-login-margin"
                >
                    <Button
                        level={4}
                        onClick={() => setState(prevState => ({
                            ...prevState,
                            recovery: true
                        }))}
                        label="Cambia tu contraseña"
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default SessionForm;